ActionList = require 'app/scripts/models/collections/action-list'
ActionListView = require 'app/scripts/views/action/action-list-view'
{ Analytics } = require '@trello/atlassian-analytics'
Payloads = require 'app/scripts/network/payloads'
ViewWithActions = require 'app/scripts/views/internal/view-with-actions'
View = require 'app/scripts/views/internal/view'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_activity')

mixin ViewWithActions, class BoardMenuActivityView extends View
  viewTitleKey: 'activity'
  viewIcon: 'activity'

  initialize: ->
    @mode = 'all'

    { @fullHistory } = @options
    @fullHistory ?= false

    @actionListView = @collectionSubview ActionListView, new ActionList(@getActions(), { @modelCache }),
      renderOpts:
        compact: !@fullHistory
        key: 'boardmenuactivity'
        context: @model

    @makeDebouncedMethods 'renderMoreActionsLink'

    @listenTo @modelCache, "add:Action:#{@model.id}", =>
      @actionListView.collection.reset(@getActions())
      @renderMoreActionsLinkDebounced()

    @listenTo @model.memberList, 'change:initials change:avatarUrl change:avatarSource change:fullName change:username': @render

    @loadMoreActions()

    return

  className: 'board-menu-content-frame'

  events:
    'click .js-show-all': 'showAll'
    'click .js-show-comments': 'showComments'
    'click .js-more-actions': 'loadMoreActions'

  render: ->

    @$el.html(
      templates.fill(
        'board_menu_activity',
        @model.toJSON()
      )
    )

    @actionListView.setElement @$('.js-list-activity')[0]
    @renderActions()
    @renderMode()

    @

  renderActions: ->
    @actionListView.render()
    @renderMoreActionsLink()

  renderMoreActionsLink: ->
    @$('.js-more-actions').toggle(@hasMoreActions())
    @

  renderMode: ->
    @$('.js-control-option').removeClass('is-active')

    if @mode == 'all'
      @$('.js-list-activity').removeClass('is-only-comments')
      @$('.js-show-all').addClass('is-active')
    else
      @$('.js-list-activity').addClass('is-only-comments')
      @$('.js-show-comments').addClass('is-active')

    @

  showAll: (e) ->
    @mode = 'all'
    @renderMode()
    track("Board Menu", "Activity", "Show All")
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'showAllActivityButton'
        source: 'boardMenuDrawerActivityScreen'
    return

  showComments: (e) ->
    @mode = 'comments'
    @renderMode()
    track("Board Menu", "Activity", "Show Comments Only")
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'showCommentsOnlyButton'
        source: 'boardMenuDrawerActivityScreen'
    return

module.exports = BoardMenuActivityView
